// import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import Tabs from 'vue-tabs-component'
import VeeValidate from 'vee-validate'
import VueResource from 'vue-resource'
import vSelect from 'vue-select'
import VueMoment from 'vue-moment'
import VueScrollTo from 'vue-scrollto'

import moment from 'moment'
import 'moment/locale/is'

import Page from './components/Page'

import auth from './services/auth'
import router from './router'
import App from './App.vue'

Vue.use(VueRouter)
Vue.use(VeeValidate)
Vue.use(VueResource)
Vue.use(Tabs)
Vue.component('v-select', vSelect)
Vue.use(VueMoment, {
  moment
})
Vue.use(VueScrollTo)

auth.checkAuth()

Vue.component('page', Page)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
